import AccountPageTemplate from 'components/shared/AccountPageTemplate'

import { FormattedMessage, useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'

const RegistrationConfirmation = () => {
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const userEmail = searchParams.get('email')

    const textWithEmail = formatMessage(
        {
            id: 'global.registration_sent_message',
            defaultMessage:
                'Dziękujemy za aktywację konta o adresie e-mail {email}.',
        },
        {
            email: userEmail && decodeURIComponent(userEmail),
        }
    )

    const textWithoutEmail = formatMessage({
        id: 'global.registration_sent_message_no_email',
        defaultMessage: 'Dziękujemy za aktywację konta.',
    })

    return (
        <AccountPageTemplate
            title={
                <FormattedMessage
                    id="global.registration_account_activated"
                    defaultMessage="Konto aktywowane!"
                />
            }
            text={userEmail ? textWithEmail : textWithoutEmail}
        />
    )
}

export default RegistrationConfirmation
